<template>
  <div>
    <b-card>
      <b-row>
        <b-col
          cols="12"
        >
          <tasks-title-card />
        </b-col>
        <b-col
          cols="12"
          md="12"
        >
          <tasks-description-card />
        </b-col>
        <b-col cols="12">
          <tasks-visibility-card />
        </b-col>
        <b-col
          v-if="!isPublic"
          cols="12"
        >
          <tasks-watchers-card />
        </b-col>
        <b-col
          cols="12"
          md="4"
        >
          <tasks-projects-card />
        </b-col>
        <b-col
          cols="12"
          md="4"
        >
          <tasks-manager-users-card />
        </b-col>
        <b-col
          cols="12"
          md="4"
        >
          <departments-card />
        </b-col>
        <b-col
          cols="12"
          md="4"
        >
          <teams-card />
        </b-col>
        <b-col
          cols="12"
          md="4"
        >
          <tasks-priority-card />
        </b-col>
        <b-col
          cols="12"
          md="4"
        >
          <tasks-start-date-card />
        </b-col>
        <b-col
          cols="12"
          md="4"
        >
          <tasks-target-date-card />
        </b-col>
        <!-- Premium alanlar -->
        <b-col
          cols="12"
          md="4"
        >
          <tasks-repeat-type-card />
        </b-col>
        <b-col
          cols="12"
          md="4"
        >
          <tasks-repeat-interval-card />
        </b-col>
        <b-col
          cols="12"
          md="12"
        >
          <tasks-repeat-config-card />
        </b-col>
        <b-col
          cols="12"
          md="4"
        >
          <tasks-next-repeat-date-card />
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import { BCard, BRow, BCol } from 'bootstrap-vue'
import TasksTitleCard from '@/views/Tasks/Elements/TitleCard.vue'
import TasksDescriptionCard from '@/views/Tasks/Elements/DescriptionCard.vue'
import TasksProjectsCard from '@/views/Tasks/Elements/ProjectsCard.vue'
import TasksManagerUsersCard from '@/views/Tasks/Elements/ManagerUsersCard.vue'
import TasksPriorityCard from '@/views/Tasks/Elements/PriorityCard.vue'
import TasksStartDateCard from '@/views/Tasks/Elements/StartDateCard.vue'
import TasksTargetDateCard from '@/views/Tasks/Elements/TargetDateCard.vue'
import TasksRepeatTypeCard from '@/views/Tasks/Elements/RepeatTypeCard.vue'
import TasksRepeatIntervalCard from '@/views/Tasks/Elements/RepeatIntervalCard.vue'
import TasksRepeatConfigCard from '@/views/Tasks/Elements/RepeatConfigCard.vue'
import TasksNextRepeatDateCard from '@/views/Tasks/Elements/NextRepeatDateCard.vue'
import DepartmentsCard from '@/views/Tasks/Elements/DepartmentsCard.vue'
import TeamsCard from '@/views/Tasks/Elements/TeamsCard.vue'
import TasksVisibilityCard from '@/views/Tasks/Elements/VisibilityCard.vue'
import TasksWatchersCard from '@/views/Tasks/Elements/WatchersCard.vue'

export default {
  name: 'TasksItemForm',
  components: {
    TeamsCard,
    DepartmentsCard,
    TasksTitleCard,
    TasksDescriptionCard,
    TasksProjectsCard,
    TasksManagerUsersCard,
    TasksPriorityCard,
    TasksStartDateCard,
    TasksTargetDateCard,
    TasksRepeatTypeCard,
    TasksRepeatIntervalCard,
    TasksRepeatConfigCard,
    TasksNextRepeatDateCard,
    TasksVisibilityCard,
    TasksWatchersCard,
    BCard,
    BRow,
    BCol,
  },
  computed: {
    isPublic() {
      return !!Number(this.$store.getters['tasks/dataItem'].is_public)
    },
  },
}
</script>
